import styled from 'styled-components';

export const PartnerLogo = styled.img`
    width: 189px;
    height: 91px;
`;



// WEBPACK FOOTER //
// ./src/components/partner/LogoPartnerComponentStyle.js